import { render } from "./TabCareer.vue?vue&type=template&id=49ac5004"
import script from "./TabCareer.vue?vue&type=script&lang=js"
export * from "./TabCareer.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/PRD_sharetreats_v1_hr_company_dashboard_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__